import React from 'react';

/**
 * Reusable people-list skeleton for messaging surfaces.
 */
export default function MessagingPeopleSkeleton({
  rows = 5,
  listClassName = 'messaging-people__list messaging-people__list--skeleton',
}) {
  return (
    <ul className={listClassName} aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <li key={i} className="messaging-people__skeleton-row">
          <span className="messaging-people__skeleton-avatar" />
          <span className="messaging-people__skeleton-body">
            <span className="messaging-people__skeleton-line messaging-people__skeleton-line--title" />
            <span className="messaging-people__skeleton-line messaging-people__skeleton-line--meta" />
          </span>
        </li>
      ))}
    </ul>
  );
}
